/**
 * @flow
 */
'use strict';

export const santeAllergiesCodes = [
{"code":"AB"},
{"code":"AINS"},
{"code":"Abeille"},
{"code":"Acariens"},
{"code":"Acetaminophene"},
{"code":"Acétate"},
{"code":"Advil"},
{"code":"Alcool"},
{"code":"Alimentaire"},
{"code":"Alimentaires"},
{"code":"Allergies ?"},
{"code":"Allergies péréniales"},
{"code":"Allergies2"},
{"code":"Alphagan"},
{"code":"Amandes"},
{"code":"Amoxicilline"},
{"code":"Amoxil"},
{"code":"Amoxil ?"},
{"code":"Amyxyne"},
{"code":"Ananas"},
{"code":"Anaprox"},
{"code":"Anesthesiant"},
{"code":"Anesthesie gen"},
{"code":"Animaux"},
{"code":"Anti-inflammatoire"},
{"code":"Anti-inflammatoire ?"},
{"code":"Antibiotique ?"},
{"code":"Aquinil"},
{"code":"Arachides"},
{"code":"Arbres"},
{"code":"Aspirine"},
{"code":"Atorvastatin"},
{"code":"Aubergine"},
{"code":"Aucun /aucune"},
{"code":"Augmentin"},
{"code":"Avelox"},
{"code":"Avenox"},
{"code":"Azithromycine"},
{"code":"Azithromycine"},
{"code":"Bactrin"},
{"code":"Beaucoup"},
{"code":"Benadryl"},
{"code":"Bezafibre"},
{"code":"Bezalip"},
{"code":"Biaxin"},
{"code":"Bouleaux"},
{"code":"Boulot"},
{"code":"Capsaicine"},
{"code":"Cari"},
{"code":"Cecla"},
{"code":"Cefaclor"},
{"code":"Cefzil"},
{"code":"Celebrex"},
{"code":"Cephalosporin"},
{"code":"Cephazil"},
{"code":"Cerise"},
{"code":"Chat "},
{"code":"Chats"},
{"code":"Chevaux"},
{"code":"Cheveu de mouton"},
{"code":"Chien"},
{"code":"Chlore"},
{"code":"Clarithromycine"},
{"code":"Clavulin"},
{"code":"Clindamycine"},
{"code":"Colorant alimentaire"},
{"code":"Cortisone"},
{"code":"Creme solaire"},
{"code":"Crevette"},
{"code":"Crustacées"},
{"code":"Demerol"},
{"code":"Dextrometorphan"},
{"code":"Diachylon"},
{"code":"Dibucaine"},
{"code":"Dilaudid"},
{"code":"Eczéma"},
{"code":"Empracet"},
{"code":"Epinephrine"},
{"code":"Erythromycine"},
{"code":"Estrogel"},
{"code":"Farine"},
{"code":"Fenofibrate"},
{"code":"Fentanyl"},
{"code":"Fievre des foins"},
{"code":"Fluviral"},
{"code":"Fraises"},
{"code":"Fruits"},
{"code":"Fruits crus"},
{"code":"Fruits de mer"},
{"code":"Fucitalmic"},
{"code":"Gazon"},
{"code":"Glutamate monosodique ?"},
{"code":"Gluten"},
{"code":"Graminés"},
{"code":"Guepe"},
{"code":"Herbe à poux"},
{"code":"Homard"},
{"code":"Hydromax"},
{"code":"Hydromorphone"},
{"code":"Ibuprofène"},
{"code":"Imitrex"},
{"code":"Incertain"},
{"code":"Inderal."},
{"code":"Insectea"},
{"code":"Into caffeine"},
{"code":"Into codeine"},
{"code":"Into lait"},
{"code":"Into noix"},
{"code":"Iode"},
{"code":"Keflex"},
{"code":"Ketchup"},
{"code":"Kiwi"},
{"code":"Lactose"},
{"code":"Lait"},
{"code":"Lapin"},
{"code":"Latex"},
{"code":"Lavande"},
{"code":"Lavendre"},
{"code":"Lentille"},
{"code":"Lidocaïne"},
{"code":"Lincomycine"},
{"code":"Lopressor"},
{"code":"Lorazepam"},
{"code":"Lécithinine"},
{"code":"Macrolides"},
{"code":"Mais crus"},
{"code":"Mandarine"},
{"code":"Mangues"},
{"code":"Maxidex"},
{"code":"Maxiran"},
{"code":"Medicaments"},
{"code":"Melon"},
{"code":"Meperidine"},
{"code":"Mercure"},
{"code":"Moissisures"},
{"code":"Morphine"},
{"code":"Morphine ?"},
{"code":"Motrin"},
{"code":"Moutarde"},
{"code":"Métal"},
{"code":"Naproxen"},
{"code":"Nexium"},
{"code":"Nickel"},
{"code":"Noix"},
{"code":"Novamoxan"},
{"code":"Oculaire"},
{"code":"Oeuf ?"},
{"code":"Oeufs"},
{"code":"Onguent topique"},
{"code":"PNC ?"},
{"code":"Pamplemousse"},
{"code":"Pantoloc"},
{"code":"Parfum"},
{"code":"Pas connu"},
{"code":"Penecilline"},
{"code":"Penicilline"},
{"code":"Petits pois"},
{"code":"Piqure insecte"},
{"code":"Pisanlit"},
{"code":"Plant de fraise"},
{"code":"Poils"},
{"code":"Poisson"},
{"code":"Pollen"},
{"code":"Pollens "},
{"code":"Polysporin"},
{"code":"Pomme"},
{"code":"Poussiere"},
{"code":"Poussière"},
{"code":"Pravachol"},
{"code":"Pseudoephrédrine"},
{"code":"Pêches"},
{"code":"Quinoa"},
{"code":"Rhume des foins"},
{"code":"Rosasol"},
{"code":"Rubarbe"},
{"code":"Saisonnière"},
{"code":"Saisonnière ?"},
{"code":"Savon"},
{"code":"Septra"},
{"code":"Serax"},
{"code":"Sesame"},
{"code":"Soleil"},
{"code":"Soya"},
{"code":"Sulfa"},
{"code":"Sulfas"},
{"code":"Tegretol"},
{"code":"Teinture"},
{"code":"Tetanos"},
{"code":"Tetracycline"},
{"code":"Timolol"},
{"code":"Tobradex"},
{"code":"Tobramycine"},
{"code":"Tobrex"},
{"code":"Tylenol"},
{"code":"Valium"},
{"code":"Valtrex"},
{"code":"Vinaigre"},
{"code":"Xylocaine"},
{"code":"Zinc PNC"},
{"code":"Zitromax"},
{"code":"Épinephrine"},
]
